<template lang="pug">

.sd-table-period
	span.sd-table-period__legend {{period}}
	.sd-table-minute(
		v-for="diff in scores"
		:key="diff.id"
	) 
		.sd-table-minute-team.sd-table-minute-team--local
			.sd-table-minute-team__value(:style="isLocalWin ? `height: ${diff/range*100}%` : `height: 0%`")
		.sd-table-minute-team.sd-table-minute-team--visitor
			.sd-table-minute-team__value(:style="isVisitorWin ? `height: ${-diff/range*100}%` : 'height: 0%'")
</template>

<script>

export default {
	name: "ScoreDevPeriod",
	props: {
        range: Number,
		period: String,
		scores: Array,
	},
	methods: {
		isLocalWin(diff) {
			return (diff > 0)
		},
		isVisitorWin(diff) {
			return (diff < 0)
		},
		isDraw(diff) {
			return (diff == 0)
		}
	}
}

</script>